import { render, staticRenderFns } from "./monthly-result.vue?vue&type=template&id=0d2c56b4&scoped=true"
import script from "./monthly-result.vue?vue&type=script&lang=js"
export * from "./monthly-result.vue?vue&type=script&lang=js"
import style0 from "./monthly-result.vue?vue&type=style&index=0&id=0d2c56b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c56b4",
  null
  
)

export default component.exports